import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThumbUpCurved: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="thumb-up-curved"><path d="M2.75 9.75H7.75V20.25H2.75V9.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12.413 2.80853L11.9418 2.75C10.5 7.5 7.75 8.46342 7.75 11.2837V17.945C7.75 18.7474 8.21423 19.489 8.97294 19.7636C11.5477 20.6953 14.2409 20.8946 16.9636 20.6601C18.6263 20.5169 19.9292 19.2409 20.2956 17.6228L21.1727 13.7486C21.6109 11.8131 20.1299 9.97331 18.1336 9.97331H13.5185L14.5039 6.79075C15.0734 4.95159 14.3343 3.0472 12.413 2.80853Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconThumbUpCurved;
